import { render } from "./grantCard.vue?vue&type=template&id=84a677a2&scoped=true"
import script from "./grantCard.vue?vue&type=script&lang=js"
export * from "./grantCard.vue?vue&type=script&lang=js"

import "./grantCard.vue?vue&type=style&index=0&id=84a677a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a677a2"]])

export default __exports__